import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import Flow1 from '../../img/4flow.png';
import Flow3 from '../../img/5flow.png';       
import HrImg from '../../img/hr-maru.png';

const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header =styled.h2`
    margin-bottom: 30px;
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const HumanImg =styled.img`
    border-radius: 50%;
`
const HumanP =styled.p`padding-left: 62px;`
const ImgCenter =styled.div`justify-items: center;`

const ParentVoice: React.VFC = () => {
  return (
    <Main>
        <p className='text-center text-2xl font-bold'>保護者様からの声</p>
        <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
        
        <ImgCenter className='mt-3 grid grid-cols-3 gap-4 sm:grid-cols-3 md:grid-cols-6'>
            <div className='col-span-3'>
                <div>
                    <img src={Flow1} alt="" />
                </div>
            </div>
            <div className='col-span-3'>
                <div>
                    <img src={Flow3} alt="" />
                </div>
            </div>
        </ImgCenter>
        
    </Main>
    
  );
}
export default ParentVoice;